import { RSAA, RSAAction } from 'redux-api-middleware';

import * as types from './applicationsActionTypes';

export const fetchApplications = (account: string, type: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${account}/applications/${type}`,
    method: 'GET',
    types: [types.FETCH_APPLICATIONS_REQUEST, types.FETCH_APPLICATIONS_SUCCESS, types.FETCH_APPLICATIONS_FAILURE],
  },
});
